class ShopifyAPI {
  constructor(url, accessToken) {
    this.url = url;
    this.accessToken = accessToken;
  }

  async updateCartDiscountCodes(cartId, discountCodes) {
    const data = {
      query: `
        mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
          cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
            cart {
              discountCodes {
                code
                applicable
              }
              discountAllocations {
                discountedAmount {
                  amount
                  currencyCode
                }
              }
              cost {
                subtotalAmount {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      `,
      variables: {
        cartId: 'gid://shopify/Cart/' + cartId,
        discountCodes: discountCodes
      }
    };
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.accessToken
      },
      body: JSON.stringify(data)
    };

    try {
      const response = await fetch(this.url, options);
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Erro:', error);
      throw new Error('Erro ao fazer requisição à API Shopify');
    }
  }
}

function formatCurrencyCart(value) {
  const integerPart = Math.floor(value / 100).toString();
  const decimalPart = (value % 100).toString().padStart(2, '0');
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${formattedInteger}.${decimalPart}`;
}

document.addEventListener("DOMContentLoaded", async function() {
  window.discountCodesFunction = function() {
    let removeCouponTimeout;

    const shopifyAccessToken = "d6f334949f3d6f4cda1ec8153f5c5275";
    const shopifyUrl = "https://totvssp-ironsstudios-dc.myshopify.com";
    const shopifyUrlApi = shopifyUrl + "/api/2024-04/graphql.json";
    const shopifyAPI = new ShopifyAPI(shopifyUrlApi, shopifyAccessToken);

    async function updateCoupons(coupons, isRemoveAction) {
      try {
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        const cartId = cartData.token;

        const result = await shopifyAPI.updateCartDiscountCodes(cartId, coupons);
        console.log(result);
        
        if (window.location.href.indexOf("/cart") > -1) {
          setTimeout(function() {
            window.location.reload();
          }, 1200);
        }

        let allApplicable = true;
        for (let i = 0; i < result.data.cartDiscountCodesUpdate.cart.discountCodes.length; i++) {
          if (!result.data.cartDiscountCodesUpdate.cart.discountCodes[i].applicable) {
            allApplicable = false;
            break;
          }
        }

        if (allApplicable) {
          document.querySelectorAll('.drawer__coupon:not(.drawer__gift)').forEach((couponDiv, index) => {
            if (isRemoveAction) {
              couponDiv.querySelector('.error').innerHTML = 'Voucher removed';
              window.reloadCartItens();
              setTimeout(function() {
                couponDiv.querySelector('.error').innerHTML = '';
              }, 2500);
            } else {
              // debugger;
              couponDiv.querySelector('.success').innerHTML = 'Voucher applied';
              couponDiv.querySelector('.drawer__coupon-input').value = '';
              window.reloadCartItens();
              setTimeout(function() {
                couponDiv.querySelector('.success').innerHTML = '';
              }, 2500);
            }
          });

          fetch(shopifyUrl)
          .then(response => {
            if (response.ok) {
              return response.text();
            }
            throw new Error('Erro ao carregar o carrinho.');
          })
          .then(html => {
            const tempElement = document.createElement('div');
            tempElement.innerHTML = html;

            const selectors = ['#CartDrawer-CartItems', 'cart-drawer-items', '.cart-drawer__footer'];

            selectors.forEach(selector => {
              const newContent = tempElement.querySelector(selector);
              if (newContent) {
                const currentElement = document.querySelector(selector);
                if (currentElement) {
                  currentElement.innerHTML = newContent.innerHTML;
                  window.discountCodesFunction();
                  //window.showShippingCalculator();
                  window.updateFreeGiftProgressBar();
                  //window.ShippingCalculator.init();
                } else {
                  throw new Error(`Elemento ${selector} não encontrado no DOM atual.`);
                }
              } else {
                throw new Error(`Div ${selector} não encontrada no HTML retornado.`);
              }
            });

            const totalCart = result.data.cartDiscountCodesUpdate.cart.cost.subtotalAmount.amount;
            document.querySelector('.totals__total-value').textContent = formatCurrency(totalCart);

            triggerUpdateCoupon();
            document.querySelectorAll('.drawer__coupon-btn').forEach(btn => btn.removeAttribute('disabled'));
            document.querySelectorAll('.remove-coupon').forEach(btn => btn.removeAttribute('disabled'));
          })
          .catch(error => {
            console.error('Erro:', error);
            document.querySelectorAll('.drawer__coupon-btn').forEach(btn => btn.removeAttribute('disabled'));
            document.querySelectorAll('.remove-coupon').forEach(btn => btn.removeAttribute('disabled'));
          });
        } else {
          document.querySelectorAll('.drawer__coupon .error').forEach(errorElem => {
            errorElem.textContent = 'CUPOM INVÁLIDO!';
            setTimeout(function() {
              errorElem.textContent = '';
          }, 2500);
          });
          document.querySelectorAll('.drawer__coupon-btn').forEach(btn => btn.removeAttribute('disabled'));
          document.querySelectorAll('.remove-coupon').forEach(btn => btn.removeAttribute('disabled'));
        }
      } catch (error) {
        console.error(error.message);
        document.querySelectorAll('.drawer__coupon-btn').forEach(btn => btn.removeAttribute('disabled'));
        document.querySelectorAll('.remove-coupon').forEach(btn => btn.removeAttribute('disabled'));
      }
    }

    async function updateCouponAction(couponValue, isRemoveAction) {
      document.querySelectorAll('.drawer__coupon .success').forEach(successElem => successElem.innerHTML = '');
      document.querySelectorAll('.drawer__coupon .error').forEach(errorElem => errorElem.innerHTML = '');
      try {
        const appliedCoupons = Array.from(document.querySelectorAll('.applied_coupon'))
          .map(couponElement => couponElement.textContent.trim());
        if (isRemoveAction) {
          const updatedCoupons = appliedCoupons.filter(coupon => coupon !== couponValue);
          await updateCoupons(updatedCoupons, true);
        } else {
          const updatedCoupons = [...appliedCoupons, couponValue];
          await updateCoupons(updatedCoupons, false);
        }
      } catch (error) {
        console.error(error.message);
      }
    }

    function triggerUpdateCoupon() {
      document.querySelectorAll('.remove-coupon').forEach(button => {
        button.addEventListener('click', function() {
          this.setAttribute('disabled', true);
          const couponToRemove = this.dataset.coupon;
          updateCouponAction(couponToRemove, true);
        });
      });

      document.querySelectorAll('.drawer__coupon-btn').forEach((button, index) => {
        const couponInput = document.querySelectorAll('.drawer__coupon-input')[index];
        if (button) {
          async function applyCoupon() {
            button.setAttribute('disabled', true);
            const couponValue = couponInput.value.trim();
            updateCouponAction(couponValue, false);
          }

          button.addEventListener('click', applyCoupon);
          couponInput.addEventListener('keypress', async function(event) {
            if (event.key === 'Enter') {
              applyCoupon();
            }
          });
        }
      });

      //update total minicart
      setTimeout(function() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(data =>   document.querySelector('.totals__total-value').textContent = '$' + formatCurrencyCart(data.total_price));   
      }, 1200);

    }

    triggerUpdateCoupon();

    function formatCurrency(value) {
      const numberValue = parseFloat(value);
      if (isNaN(numberValue)) {
        return 'Valor inválido';
      }
      const formattedValue = numberValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      });
      return formattedValue;
    }


    //update cart itens
    window.reloadCartItens = function() {
      let mainCartItems = document.querySelector('.drawer__inner');

      fetch(window.location.href)
        .then(response => response.text())
        .then(data => {
          let tempElement = document.createElement('div');
          tempElement.innerHTML = data;
          mainCartItems.innerHTML = tempElement.querySelector('.drawer__inner').innerHTML;
          window.atualizarAbasCart();
          window.discountCodesFunction();
          window.ShippingCalculator.init();
          window.atualizarProgressBar();
        })
        .catch(error => console.error('Erro ao carregar o conteúdo: ', error));
    }

    //app share cart
    // setTimeout(function() {
    //   document.getElementById('btn-share-cart').addEventListener('click', function() {
    //     // debugger
    //       var sacButton = document.getElementById('sac-share-a-cart-btn');
    //       if (sacButton) {
    //           sacButton.click();
    //       }
    //   });
    // }, 1200);
    
  }
  window.discountCodesFunction();
});
